import { useCallback, useRef, useEffect } from "react";
import { ErrorMessage, useField } from "formik";
import ReactQuill, { Quill } from "react-quill";
// import Quill from "quill";
import "react-quill/dist/quill.snow.css";

import SuccessAndErrorMessage from "@/pages/configuration/components/SuccessAndErrorMessage";
import { useImageUploadMutation } from "@/app/features/imageupload/imageUploadApiSlice";

import useSnackbar from "@/hooks/use-snackbar";

var Image = Quill.import("formats/image");
Image.className = "ql-image-style";
// Image.style = "height:100%;width:100%;";
Quill.register(Image, true);

function TinyEditor({ name, dataTextName, onChange, onBlur, onChangeText }) {
  const [field] = useField(name);
  // Editor ref
  const quill = useRef();

  const [imageUpload] = useImageUploadMutation();
  const { showSnackbar, snackbar } = useSnackbar();

  // useEffect(() => {
  //   if (quill.current) {
  //   }
  // }, [quill]);

  const imageHandler = useCallback(() => {
    // Create an input element of type 'file'
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    // When a file is selected
    input.onchange = async () => {
      const file = input.files[0];
      const formData = new FormData();
      formData.append("image", file);

      const { data, error } = await imageUpload(formData);
      if (error) {
        showSnackbar({
          message: "Some error occurred",
          type: "error",
        });
        return;
      }

      showSnackbar({ message: "Image uploaded Successfully " });
      const quillEditor = quill.current.getEditor();

      // Get the current selection range and insert the image at that index
      const range = quillEditor.getSelection(true);
      quillEditor.insertEmbed(range.index, "image", data.data.imageUrl, "user");
    };
  }, []);

  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ direction: "rtl" }], // text direction
        // [{ size: ["small", false, "large", "huge"] }], // custom dropdown

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: [] }],
        [{ align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
      formats: ["image", "custom-style"],
      handlers: {
        image: imageHandler,
      },
    },
    clipboard: {
      matchVisual: true,
    },
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",

    "blockquote",
    "code-block",

    "list",
    "ordered",
    "bullet",
    "check",

    "script",
    "indent",

    "color",
    "background",

    "link",
    "image",
    "video",

    "font",
    "size",
    "align",

    "clean",
  ];

  return (
    <>
      {snackbar}
      <ReactQuill
        ref={(el) => (quill.current = el)}
        className="editor"
        theme="snow"
        value={field.value}
        onChange={(value) => {
          onChange(value);
          if (quill.current) {
            const text = quill.current?.unprivilegedEditor.getText();
            // onChangeText(text);
          }
        }}
        onBlur={onBlur}
        modules={modules}
        formats={formats}
      />
      <ErrorMessage name={name}>
        {(message) => <SuccessAndErrorMessage error={message} />}
      </ErrorMessage>
    </>
  );
}

export default TinyEditor;
